<script>
  import { M } from '../../external.js';
  import { onMount } from 'svelte';

  export let folderName = '';
  export let onFolderNameChange = () => {
  };

  let headerText = !!folderName ? M.RENAME : M.CREATE_A_FOLDER;
  let input;

  onMount(() => {
    input?.focus();
  })
</script>
<div id="test-video-folder" data-force-right="false" data-width="400" data-title="">
  <div class="popup-widget-wrapper">
    <div class="col20 f-left t-center mt-15">
      <span class="material-icons-outlined fingerprint-icon"> folder </span>
    </div>
    <h4 class="col20 f-left mt-15 mb-15 t-center h4-bigger">{headerText}</h4>
    <div class="popup-input-wrapper mb-15">
      <input type="text" name="imageDescription" bind:this={input} bind:value={folderName} on:input={() => onFolderNameChange(folderName)}
             placeholder={M.ENTER_FOLDER_NAME} />
    </div>
  </div>
</div>
